import { createContext } from 'react';

import { IChipItem } from '../../../../ui/FormChipInput/ChipItem';

export interface IAddNewUsersInitialState {
    email_list: IChipItem[];
    hasSelectedPermission: boolean;
}

export const AddNewUsersInitialState: IAddNewUsersInitialState = {
    email_list: [],
    hasSelectedPermission:false
}

const AddNewUsersContext = createContext<any>(
    AddNewUsersInitialState
);

export default AddNewUsersContext;
